import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=3e35cebb&scoped=true"
import script from "./DetailPage.vue?vue&type=script&lang=js"
export * from "./DetailPage.vue?vue&type=script&lang=js"
import style0 from "./DetailPage.vue?vue&type=style&index=0&id=3e35cebb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e35cebb",
  null
  
)

export default component.exports